module.exports = __webpack_public_path__ + "31f74413ffd852d375848ddcef3c431e.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/PK.svg
// module id = ZXvj
// module chunks = 0